module.exports = __webpack_public_path__ + "static/Couatl-c8a7646846052ecdaa38c298cef76176.jpg";